import React, { Component } from 'react'
import PropTypes from 'prop-types';
import SelectWithSearch from "./SelectWithSearch"
import APIManager from 'modules/common/apiManager';
export class SelectFilterAPI extends Component {
  constructor(props){
    super(props);
    this.mAPI = new APIManager();
    this.state = {
      loading : false,
      limit : props.limit || 20,
      options : props.options || [],
      addFilter: props.addFilter || ""
    }
    this.timer = "";
    this.getData = this.getData.bind(this);
    this.onSearch = this.onSearch.bind(this);
    // this.getData();
  }
  
  componentWillUpdate(nextProps) {
    if (this.state.addFilter !== nextProps.addFilter) {
      this.setState({addFilter : nextProps.addFilter,options:[],loading : false});
    }
  }

  getData( search ){
    const { dataUrl, dataLabel, dataValue, filter, latestFirst } = this.props
    let latest = latestFirst? "&orderBy=create_at&order=DESC": "";
    let _this  = this;
    let searchQuery = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    if (filter) {
      searchQuery += `&${filter}`;
    }
    _this.setState({loading : true});
    this.mAPI.sendGetAPI(
      `${dataUrl}?limit=${this.state.limit}&page_no=1${searchQuery}${_this.state.addFilter || ""}${latest || ""}`,
      data => {
        if (data && data.data) {
          // that.setState({ listData: data.data });
          let options = [];
          const nextCursor = data.nextCursor ? data.nextCursor : "";
          data.data.map(data => {
            options.push({
              value: dataValue && data[dataValue] ? data[dataValue] :  data._id || "",
              data : data,
              label: dataLabel && data[dataLabel] ? data[dataLabel] :  data.name || "",
              nextCursor : nextCursor || ""
            });
          });
          _this.setState({"options":options,loading : false});
        } else {
          _this.setState({"options":[],loading : false});
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          _this.setState({"options":[],loading : false});
        } else {
          _this.setState({"options":[],loading : false});
        }
      },
      this.props.global === true ? "public" : ""
    );
  }
  onSearch( search ) {
    let _this = this;
    search = search == "reload" ? "" : search;
    clearTimeout(this.timer);
    _this.setState({"loading":true})
    _this.timer = setTimeout(()=>{
      _this.getData( search );
    },350)
  }

  render() {
    const { selected, label, name, onSelect, multi, initialValues, showAvatar ,...extraProp  } = this.props
    return (
      <SelectWithSearch
        loading={this.state.loading}
        initialValues={initialValues}
        selectedValues={selected}
        totalOptions={this.state.options}
        label={label}
        onSelect={onSelect}
        name={name}
        search={this.onSearch}
        multi={multi}
        customOption=""
        showAvatar={showAvatar || false}
        {...extraProp}
      />
    )
  }
}
SelectFilterAPI.contextTypes = {
  __: PropTypes.func
};

export default SelectFilterAPI;



// WEBPACK FOOTER //
// src/modules/common/components/form/SelectFilterAPI.js